import React, { useState, useEffect } from 'react';
import { HotelMenuBar } from '@lt/components';
import Container from '../Container';

import styles from './topMenu.module.css';

const TopMenu = (props) => {
  /* force rerender on client, issue: https://github.com/vercel/next.js/issues/7417#issuecomment-509411508 */
  const [isSSR, setIsSSR] = useState(true);

  useEffect(() => {
    setIsSSR(false);
  }, []);

  if (isSSR) {
    return <div className={styles.skeletonMenuBar} />;
  }

  return (
    <Container className={styles.hotelMenuBarContainer} marginBottom={16}>
      <HotelMenuBar className={styles.hotelMenuBar} {...props} />
    </Container>
  );
};

export default React.memo(TopMenu);
